import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import { I18nProvider } from '../i18n/I18nProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { appRouter } from './router';
import { AppRouteFallback, SessionToast } from './routes/guards';

function App() {
  return (
    <ErrorBoundary>
      <I18nProvider>
        <SessionToast />
        <Suspense fallback={<AppRouteFallback />}>
          <RouterProvider router={appRouter} />
        </Suspense>
      </I18nProvider>
    </ErrorBoundary>
  );
}

export default App;
